module.exports = __webpack_public_path__ + "img/logo_selvasocr_30.d8bbb5d3.png";